import { fetcher } from '@portal/shared/utils/fetcher/fetcher';
import { useMutation } from '@tanstack/react-query';
import { apiRoutes } from '@portal/constants/routes';
import { useStoreValue } from '@portal/state/hooks/useStore';
import { AddDiscountcodesToCartRequest, AddDiscountCodesToCartResponse } from './types';

export const useMutationAddDiscountCodesToCart = () => {
  const store = useStoreValue();

  return useMutation({
    mutationFn: async ({ input }: AddDiscountcodesToCartRequest) => {
      const { data: response } = await fetcher.post(
        apiRoutes.offer.addDiscountCodesToCart({ store }),
        { input }
      );
      return response as AddDiscountCodesToCartResponse;
    },
    onSuccess: (response, { onSuccess }) => {
      onSuccess?.(response);
    },
    onError: (error, { onError }) => {
      onError?.(error);
    }
  });
};
